import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_9 = {
  key: 0,
  class: "badge text-outline-danger"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 5 }
const _hoisted_15 = { key: 6 }
const _hoisted_16 = { key: 7 }
const _hoisted_17 = { key: 8 }
const _hoisted_18 = { key: 9 }
const _hoisted_19 = { key: 10 }
const _hoisted_20 = { key: 11 }
const _hoisted_21 = { key: 12 }
const _hoisted_22 = { class: "col-md-6 col-xxl-6 col-sm-6 mb-10" }
const _hoisted_23 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_24 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_25 = { class: "table" }
const _hoisted_26 = {
  key: 0,
  class: "col-md-6 col-xxl-6 col-sm-6 mb-10"
}
const _hoisted_27 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_28 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_29 = { class: "table" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "col-md-6 col-xxl-6 col-sm-6 mb-10"
}
const _hoisted_32 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_33 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_34 = { class: "table" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "col-md-6 col-xl-6 col-sm-6 mb-10" }
const _hoisted_38 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_39 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_40 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
            (_ctx.abonnement?.estMPostBox === false)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/liste-abonnements",
                  class: "btn btn-primary transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Retour", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.abonnement?.estMPostBox === true)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/liste-mpostboxs",
                  class: "btn btn-primary transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Retour", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("table", _hoisted_6, [
            _createElementVNode("tbody", null, [
              (_ctx.abonnement)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "Etat : ", -1)),
                    _createElementVNode("td", _hoisted_8, [
                      (_ctx.abonnement.etat == 'Résilié')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.abonnement.etat), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.refAbo)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "Référence", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.refAbo), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.demande?.refDemande)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Demande", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.demande.refDemande), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.adresseVirtuelle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, "Adresse virtuelle", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.adresseVirtuelle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.boite?.adressePostale?.adresse_postale)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, "Adresse postale", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.adressePostale?.adresse_postale), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.loyer)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "Loyer", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.loyer), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.caution)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _cache[10] || (_cache[10] = _createElementVNode("td", null, "Caution", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.abonnement?.caution)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.fraisCle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _cache[11] || (_cache[11] = _createElementVNode("td", null, "Frais clé", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.abonnement?.fraisCle)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.montant)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _cache[12] || (_cache[12] = _createElementVNode("td", null, "Montant total", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.separateur(_ctx.abonnement?.montant)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.numero)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _cache[13] || (_cache[13] = _createElementVNode("td", null, "Numéro", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.numero), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.nombreCle)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                    _cache[14] || (_cache[14] = _createElementVNode("td", null, "Nombre clé", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.nombreCle), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.typeBoite)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                    _cache[15] || (_cache[15] = _createElementVNode("td", null, "Type de boîte", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.typeBoite), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.abonnement?.createdAt)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                    _cache[16] || (_cache[16] = _createElementVNode("td", null, "Date d'abonnement", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date(_ctx.abonnement?.createdAt)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _cache[18] || (_cache[18] = _createElementVNode("td", null, null, -1)),
                _createElementVNode("td", null, [
                  (_ctx.abonnement?.etat == 'En attente' && _ctx.checkPermission('ValidAbonnement'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary transition border-0 lh-1 fw-medium fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.valideAbonnement()))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "flaticon-check lh-1 me-1 position-relative top-2" }, null, -1),
                        _createElementVNode("span", { class: "position-relative" }, null, -1),
                        _createTextVNode(" Valider l'abonnement", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _cache[31] || (_cache[31] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Information sur l'abonné", -1)),
          _createElementVNode("table", _hoisted_25, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[20] || (_cache[20] = _createElementVNode("td", null, "Nom et prénom", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.nomComplet), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[21] || (_cache[21] = _createElementVNode("td", null, "Nationalité", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.nationalite), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[22] || (_cache[22] = _createElementVNode("td", null, "Téléphone", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.telephone), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[23] || (_cache[23] = _createElementVNode("td", null, "Date de naissance", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(_ctx.abonnement?.abonne?.dateNaissance)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[24] || (_cache[24] = _createElementVNode("td", null, "Email", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.email), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[25] || (_cache[25] = _createElementVNode("td", null, "Sexe", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.sexe), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[26] || (_cache[26] = _createElementVNode("td", null, "Profession", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.profession), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[27] || (_cache[27] = _createElementVNode("td", null, "Adresse de résidence", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.adresseResidence), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[28] || (_cache[28] = _createElementVNode("td", null, "Ville de résidence", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.villeResidence), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[29] || (_cache[29] = _createElementVNode("td", null, "Catégorie de l'abonné", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.categorieAbonne?.libelle), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[30] || (_cache[30] = _createElementVNode("td", null, "Secteur d'activité", -1)),
                _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.abonne?.activite?.libelle), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (!_ctx.abonnement?.estMPostBox)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[37] || (_cache[37] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Information sur la boîte postale", -1)),
              _createElementVNode("table", _hoisted_29, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[32] || (_cache[32] = _createElementVNode("td", null, "Référence", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.refBoite), 1)
                  ]),
                  (_ctx.abonnement?.bureau?.nom)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                        _cache[33] || (_cache[33] = _createElementVNode("td", null, "Agence", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.bureau?.nom), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _cache[34] || (_cache[34] = _createElementVNode("td", null, "Couleur", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.couleur), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[35] || (_cache[35] = _createElementVNode("td", null, "Dimension", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.dimension), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[36] || (_cache[36] = _createElementVNode("td", null, "Etat", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.boite?.etat), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.abonnement?.quartier)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _cache[42] || (_cache[42] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Adresse complète pour la domiciliation", -1)),
              _createElementVNode("table", _hoisted_34, [
                _createElementVNode("tbody", null, [
                  (_ctx.abonnement?.quartier?.arrondissement)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                        _cache[38] || (_cache[38] = _createElementVNode("td", { class: "bld" }, "Arrondissement", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.quartier?.arrondissement.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.abonnement?.quartier)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                        _cache[39] || (_cache[39] = _createElementVNode("td", { class: "bld" }, "Quartier", -1)),
                        _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.quartier?.libelle), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _cache[40] || (_cache[40] = _createElementVNode("td", { class: "bld" }, "N° Carré / Maison", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.adresseMaisonCarre), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[41] || (_cache[41] = _createElementVNode("td", { class: "bld" }, "Directive", -1)),
                    _createElementVNode("td", null, _toDisplayString(_ctx.abonnement?.directive), 1)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _cache[44] || (_cache[44] = _createElementVNode("h4", { class: "text-black fw-bold mb-10" }, "Historique des transferts", -1)),
          _createElementVNode("table", _hoisted_40, [
            _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Ancienne agence "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nouvelle agence "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Boite "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date de transfert ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.abonnement?.transferts, (transfert, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(transfert?.ancienneAgence?.nom), 1),
                  _createElementVNode("td", null, _toDisplayString(transfert?.nouvelleAgence?.nom), 1),
                  _createElementVNode("td", null, _toDisplayString(transfert?.boite?.refBoite), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.format_date(transfert?.createdAt)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}